import React, { Component } from "react";
import Button from "../../../../components/bases/button/button";
import AssetsManager from "../assetsmanager/assetsmanager.js";
import Dialog from "../../../dialogs/dialog";


import "./selectassets.css"
import AppHeader from "../appheader/appheader.js";


class SelectAssets extends Dialog
{
  constructor(props) 
  {
    super(props);

    const title = {fr:"Liste des assets",  en:"Assets List",}
    this.state.title = title;
    this.state.displayform = true;

    var buttons = [];
    buttons.push({type:"text", disabled:false,text:{fr:"Ajouter",en:"Add"},key:"add"})
    buttons.push({type:"back", text:{fr:"Terminé",en:"Back"}, disabled:false});
    

    this.state.buttons = buttons;
    this.onQuit = this.onQuit.bind(this)
    this.onGetTableList = this.onGetTableList.bind(this)
    this.handleButton = this.handleButton.bind(this)

    this.assetsManagerRef = React.createRef();
   
  }

  handleButton(buttonkey)
  {
    console.log("on click", buttonkey)
    switch (buttonkey)
    {
        case "back":
          this.onQuit();
          break;
        case "add":
          this.assetsManagerRef.current.queryNewFile();
          break;
    }
   
  }

  onQuit()
  {
      this.props.onvalidform({ret:false})
  }

  onValid()
  {
    alert ("on valide");
  }

  onGetTableList(datas)
  {
    console.log("GET LISTE ASSETS ",datas)

  }


  componentDidMount()
  {
    super.componentDidMount();
  }


  render()
  {
    var maxwidth =  (window.innerWidth * 45)/100;
    if (maxwidth > 800) maxwidth = 800;

    var maxheight =  (window.innerHeight * 75)/100;
    if (maxheight > 400) maxheight = 400;

    var localrender =[];
    

    localrender.push(
      <>
            <div className="table-limit" style={{width:maxwidth, height:maxheight}}>
              <div className="selectAssetHeader">
                <AppHeader pjid= {this.props.pjid}/>
              </div>
              <div className="selectAssetBody">
                <AssetsManager 
                  pjid={this.props.pjid} 
                  mode = "view"
                  setCancelKey = {this.setCancelKeyDialog}
                  ref={this.assetsManagerRef}/>

              </div>
              

            </div>          
                

      </>          
      );



    return super.render(localrender);
  }


}
SelectAssets.defaultProps = 
{
    zorder:2,
    pjid: 0,
    
}


export default SelectAssets;